import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumCreditCalculationType implements BaseEnumType {
  private static allValues: EnumCreditCalculationType[] = []; // make sure this is top-most
  
  public static none = new EnumCreditCalculationType(0, "None", "enum_credit_calculation_type_none");
  public static ofFollowingMonth = new EnumCreditCalculationType(1, "OfFollowingMonth", "enum_credit_calculation_type_of_following_month");
  public static daysAfterInvoice = new EnumCreditCalculationType(2, "DaysAfterInvoice", "enum_credit_calculation_type_days_after_invoice");
  public static daysAfterInvoiceMonth = new EnumCreditCalculationType(3, "DaysAfterInvoiceMonth", "enum_credit_calculation_type_days_after_invoice_month");
  public static ofCurrentMonth = new EnumCreditCalculationType(4, "OfCurrentMonth", "enum_credit_calculation_type_of_current_month");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCreditCalculationType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumCreditCalculationType.none; }
  public isOfFollowingMonth() { return this === EnumCreditCalculationType.ofFollowingMonth; }
  public isDaysAfterInvoice() { return this === EnumCreditCalculationType.daysAfterInvoice; }
  public isDaysAfterInvoiceMonth() { return this === EnumCreditCalculationType.daysAfterInvoiceMonth; }
  public isOfCurrentMonth() { return this === EnumCreditCalculationType.ofCurrentMonth; }

  public static getValues(): readonly EnumCreditCalculationType[] {
    return EnumCreditCalculationType.allValues;
  }

  public static getValuesExcept0(): readonly EnumCreditCalculationType[] {
    return EnumCreditCalculationType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumCreditCalculationType {
    const found = EnumCreditCalculationType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumCreditCalculationType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumCreditCalculationType): EnumCreditCalculationType {
    const found = name ? EnumCreditCalculationType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumCreditCalculationType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumCreditCalculationType>): boolean {
    return this.key === other?.key;
  }
}